import { render, staticRenderFns } from "./bookCard.vue?vue&type=template&id=06eb8ff2&scoped=true&"
import script from "./bookCard.vue?vue&type=script&lang=js&"
export * from "./bookCard.vue?vue&type=script&lang=js&"
import style0 from "./bookCard.vue?vue&type=style&index=0&id=06eb8ff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eb8ff2",
  null
  
)

export default component.exports